<template>
  <el-form
    :model="ruleForm"
    :rules="rules"
    ref="multipleTable"
    label-width="100px"
    class="demo-ruleForm"
  >
    <el-form-item label="合同编号" prop="contract">
      <el-input v-model="ruleForm.contract"></el-input>
    </el-form-item>
    <el-form-item label="单位信息" prop="danwei">
      <el-input v-model="ruleForm.danwei"></el-input>
    </el-form-item>
    <el-form-item label="合同日期" required>
      <el-col :span="11">
        <el-form-item prop="date1">
          <el-date-picker
            v-model="ruleForm.value1"
            type="date"
            placeholder="选择日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
      </el-col>
    </el-form-item>
    <el-form-item label="备注" prop="textarea1">
      <el-input
        type="textarea"
        autosize
        placeholder="如需备注,请输入内容"
        v-model="ruleForm.textarea1"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <div class="box">
        <input
          type="file"
          name="file-1[]"
          id="file-1"
          @input="inputfunc"
          class="inputfile inputfile-1"
          data-multiple-caption="{count} files selected"
          multiple
        />
        <label for="file-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="17"
            viewBox="0 0 20 17"
          >
            <path
              d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"
            />
          </svg>
          <span>点击上传合同电子版&hellip;</span>
        </label>
      </div>
    </el-form-item>
    <el-dialog
      title="加密锁详情"
      :visible.sync="dialogTableVisible"
      v-if="dialogTableVisible"
    >
      <el-form-item>
        {{ "加密锁号" }}
        <el-input v-model="ruleForm.jiamisuo" clearable></el-input>
      </el-form-item>
      <el-form-item>
        {{ "内部锁号" }}
        <el-input v-model="ruleForm.suohao" clearable></el-input>
      </el-form-item>
      <el-form-item v-for="(modelform, index) in ruleForm.module" :key="index">
        {{ modelform.name }}
        <el-input :readonly="true" v-model="ruleForm.mokuai[index]">
          <el-button slot="append">
            <app-Modular
              @ievent="ievent"
              :ruleForm="modelform"
              :index="Number(index)"
            ></app-Modular>
          </el-button>
        </el-input>
      </el-form-item>
      <el-button type="primary" @click="submitCodemeter('ruleForm')"
        >确认上传</el-button
      >
    </el-dialog>
    <el-form-item>
      <el-button
        type="primary"
        @click="submitForm('ruleForm')"
        :disabled="jinyong"
        >立即创建</el-button
      >
    </el-form-item>
    <el-form-item>
      <el-button type="success" @click="Getform" v-if="codemeter"
        >新增加密锁</el-button
      >
    </el-form-item>
  </el-form>
</template>
<script>
export default {
  data() {
    return {
      codemeter: false,
      quanbuchanpin: [],
      ruleForm: {
        contract: "",
        jiamisuo: "",
        suohao: "",
        danwei: "",
        value1: "",
        mokuai: {},
        textarea1: "",
        contractId: "",
        module: {},
      },
      jinyong: false,
      dialogTableVisible: false,
      formLabelWidth: "120px",
      rules: {
        contract: [
          { required: true, message: "请输入合同编号", trigger: "blur" },
          {
            min: 1,
            max: 99,
            message: "长度在 1 到 99 个字符",
            trigger: "blur",
          },
        ],
        danwei: [
          { required: true, message: "请输入单位信息", trigger: "blur" },
          { min: 1, max: 99, message: "长度在1-99个字符", trigger: "blur" },
        ],
        value1: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    Getform() {
      (this.ruleForm.jiamisuo = ""),
        (this.ruleForm.suohao = ""),
        (this.ruleForm.mokuai = {}),
        this.$http
          .post(this.$getaxiosurl("/enc/product/getAllPMInfo"))
          .then((response) => {
            if (response.data.code == "00100") {
              for (var i = 0; i < response.data.data.length; i++) {
                this.$set(this.ruleForm.module, i, response.data.data[i]);
              }
              this.dialogTableVisible = true;
            } else {
              this.tableData = null;
              this.$message({
                message: "没有相关合同信息",
                type: "error",
              });
            }
          });
    },
    inputfunc() {
      var inputs = document.querySelectorAll(".inputfile");
      Array.prototype.forEach.call(inputs, function (input) {
        var label = input.nextElementSibling,
          labelVal = label.innerHTML;
        input.addEventListener("change", function (e) {
          var fileName = "";
          if (this.files && this.files.length > 1)
            fileName = (
              this.getAttribute("data-multiple-caption") || ""
            ).replace("{count}", this.files.length);
          else fileName = e.target.value.split("\\").pop();
          if (fileName) label.querySelector("span").innerHTML = fileName;
          else label.innerHTML = labelVal;
        });
      });
    },
    //桥博4接收子组件传值
    ievent(data, index) {
      let asdasd = "";
      for (let i = 0; i < data.length; i++) {
        asdasd =
          asdasd + data[i].moduleName + "—" + data[i].node + "节点" + ",";
        this.quanbuchanpin.push(data[i]);
      }
      this.$set(this.ruleForm.mokuai, index, asdasd);
    },
    submitForm() {
      var fileInput = document.getElementById("file-1");
      if (fileInput.files.length <= 0) {
        return this.$message({
          showClose: true,
          message: "请选择合同电子版",
          type: "error",
        });
      }
      this.jinyong = true;
      let formData = new FormData();
      formData.append("remark", this.ruleForm.textarea1);
      formData.append("contractNo", this.ruleForm.contract);
      formData.append("contractDate", this.ruleForm.value1);
      formData.append("companyName", this.ruleForm.danwei);
      formData.append(
        "contractFile",
        fileInput.files[0],
        fileInput.files[0].name
      );
      this.$http
        .post(this.$getaxiosurl("/enc/contract/createCon"), formData)
        .then((response) => {
          this.ruleForm.contractId = response.data.contractId;
          if (response.data.code == "00100") {
            this.$message({
              message: "数据录入成功,请点击创建加密锁录入锁信息",
              type: "success",
              duration: 8000,
            });
            this.codemeter = true;
            this.jinyong = false;
          } else {
            if (response.data.code != "00100") {
              this.$message({
                showClose: true,
                message: response.data.msg,
                type: "error",
              });
            }
            this.jinyong = false;
          }
        });
    },
    submitCodemeter() {
      if (
        this.ruleForm.jiamisuo.length <= 0 ||
        this.ruleForm.suohao.length <= 0
      ) {
        return this.$message({
          showClose: true,
          message: "加密锁号,内部锁号不能为空",
          type: "error",
        });
      }
      let Params = {
        encryptNo: this.ruleForm.jiamisuo,
        innerEncryptNo: this.ruleForm.suohao.trim(),
        contractId: this.ruleForm.contractId,
        modules: this.quanbuchanpin,
      };
      this.$http
        .post(
          this.$getaxiosurl("/enc/contract/createLock"),
          JSON.stringify(Params)
        )
        .then((response) => {
          if (response.data.code == "00100") {
            this.$message({
              message: "数据录入成功",
              type: "success",
            });
            this.dialogTableVisible = false;
          } else {
            if (response.data.code != "00100") {
              this.$message({
                showClose: true,
                message: response.data.msg,
                type: "error",
              });
            }
          }
          this.quanbuchanpin = [];
        });
    },
  },
};
</script>
<style scoped>
.el-dialog {
  width: 80% !important;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.js .inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.inputfile + label {
  max-width: 80%;
  font-size: 1.25rem;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  padding: 0.625rem 1.25rem;
}
.no-js .inputfile + label {
  display: none;
}
.inputfile:focus + label,
.inputfile.has-focus + label {
  outline: 1px dotted #000;
  outline: -webkit-focus-ring-color auto 5px;
}
.inputfile + label svg {
  width: 1em;
  height: 1em;
  vertical-align: middle;
  fill: currentColor;
  margin-top: -0.25em;
  margin-right: 0.25em;
}
.inputfile-1 + label {
  color: #f1e5e6;
  background-color: #409eff;
}
.inputfile-1:focus + label,
.inputfile-1.has-focus + label,
.inputfile-1 + label:hover {
  background-color: #67c23a;
}
</style>
